var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 350,
    viewBox: "0 0 400 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.994 91.5518C145.315 91.5518 134.226 80.4593 134.226 66.7759C134.226 53.0926 145.315 42 158.994 42C172.672 42 183.761 53.0926 183.761 66.7759C183.761 80.4593 172.672 91.5518 158.994 91.5518Z",
    fill: "#EA3377"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30346 279.484C32.8188 235.417 66.5682 178.016 72.2411 168.326C72.7549 166.568 73.4332 164.785 74.3684 162.991C81.1101 149.847 88.16 136.853 95.3539 123.946C87.7284 124.542 80.0824 125.133 72.462 125.724C67.2208 136.056 62.0052 146.393 56.7743 156.72C48.3523 173.359 23.4257 158.719 31.827 142.127C38.5687 128.798 46.559 98.8202 63.963 97.4683C82.482 96.029 100.996 94.5897 119.51 93.1556C119.962 93.1196 120.347 93.1813 120.779 93.1813C134.776 89.4341 151.183 99.3136 154.153 113.588C163.618 134.092 177.21 150.104 200.014 156.787C217.865 162.009 210.26 189.905 192.332 184.662C169.79 178.062 153.598 165.139 141.323 148.13C133.887 161.392 126.627 174.736 119.669 188.265C134.966 198.818 148.331 211.581 160.042 226.308C163.31 230.415 163.87 234.641 162.77 238.357C162.812 239.745 162.724 241.184 162.329 242.747C157.822 260.594 153.321 278.41 148.809 296.236C144.025 315.234 113.96 309.837 118.785 290.715C123.076 273.727 127.372 256.738 131.662 239.74C120.902 227.048 108.215 216.007 93.7198 207.762C90.3079 205.819 88.16 203.141 86.9679 200.191C67.1386 230.59 47.3041 272.647 27.485 298.138C15.3891 313.692 -8.8079 295.069 3.30346 279.484Z",
    fill: "#EA3377"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 24,
    rx: 5,
    transform: "matrix(-1 0 0 1 380 162)",
    fill: "#FF005D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 24,
    rx: 5,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 320 247)",
    fill: "#FF005F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.fb1a5708ce4613da7fb865a2722dd207.svg";
export { ForwardRef as ReactComponent };